export default __webpack_public_path__ + "static/media/protein.ffbc3b88.svg";